import { PaymentMethodType } from '../types'
import { FETCH, FETCH_SUCCESS } from './actionTypes'
import { PaymentMethodWithdrawFeesAnMinData } from './reducers'

export type Fetch = {
  payload: { paymentMethod: PaymentMethodType | 'ALL' }
  type: typeof FETCH
}

export const fetch = (paymentMethod: PaymentMethodType | 'ALL'): Fetch => ({
  payload: { paymentMethod },
  type: FETCH
})

export type FetchSuccess = {
  payload: { data; paymentMethod: PaymentMethodType | 'ALL' }
  type: typeof FETCH_SUCCESS
}

export const fetchSuccess = (
  paymentMethod: PaymentMethodType | 'ALL',
  data: PaymentMethodWithdrawFeesAnMinData
): FetchSuccess => ({
  payload: { data, paymentMethod },
  type: FETCH_SUCCESS
})

export type WithdrawFeesAnMinActions = Fetch | FetchSuccess
